module.exports = __webpack_public_path__ + "static/media/calltoaction.a12ed9ef.webp";